import { render, staticRenderFns } from "./Topic2KV.vue?vue&type=template&id=32f776e6&scoped=true"
import script from "./Topic2KV.vue?vue&type=script&lang=js"
export * from "./Topic2KV.vue?vue&type=script&lang=js"
import style0 from "./Topic2KV.vue?vue&type=style&index=0&id=32f776e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f776e6",
  null
  
)

export default component.exports